export * from './CustomerAvatarMenu.ui';
